import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

export const STORY_TYPE_OPTIONS = [
  { value: null, key: 'story_type_all', fallback: 'All' },
  { value: 1, key: 'story_type_social', fallback: 'Social Stories' },
  { value: 2, key: 'story_type_schedule', fallback: 'Visual Schedules' },
  { value: 3, key: 'story_type_photo', fallback: 'Photo Stories' },
];

export function getStoryTypeLabel(type, t) {
  const option = STORY_TYPE_OPTIONS.find((item) => item.value === Number(type));
  return option ? (t?.[option.key] || option.fallback) : (t?.story_type_social || 'Social Stories');
}

export default function StoryTypeFilter({ value, onChange, t, disabled = false, sx = {} }) {
  return (
    <TextField
      select
      size="small"
      label={t?.story_type_filter || 'Filter by story type'}
      value={value ?? 'all'}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value === 'all' ? null : Number(event.target.value))}
      sx={{ width: { xs: '100%', sm: 230 }, mb: 2, ...sx }}
    >
      {STORY_TYPE_OPTIONS.map((option) => (
        <MenuItem key={option.key} value={option.value ?? 'all'}>
          {t?.[option.key] || option.fallback}
        </MenuItem>
      ))}
    </TextField>
  );
}
